module.exports = __webpack_public_path__ + "img/step3-main2.0c6e2948.png";